import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "@/components/site/Motion";

export default function HomeFaq({ items, brief }) {
  return (
    <section data-testid="home-faq" className="border-b border-ash bg-white/40">
      <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-20 md:px-10 md:py-28 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow>RenB in brief</Eyebrow>
          <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight md:text-5xl">
            What is RenB Solutions?
          </h2>
          <p data-testid="home-brief" className="mt-6 max-w-xl text-base leading-relaxed text-obsidian/70">
            {brief}
          </p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
          <Accordion type="single" collapsible className="border-t border-obsidian/15">
            {items.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-obsidian/15">
                <AccordionTrigger
                  data-testid={`home-faq-trigger-${i}`}
                  className="py-5 font-serif text-lg font-medium tracking-tight hover:no-underline hover:text-progress md:text-xl [&>svg]:text-progress"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-obsidian/70">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
